import {
  call, put, delay, select,
} from 'redux-saga/effects';
import moment from 'moment';
import processError from '../../../utils/processError';
import {
  addProgressLog, setLogList, setProgressList, showProgressBar, stoppedProgressBar,
} from '../../System/actions';
import {
  rollbackVersionSuccessful,
  rollbackVersionFailed,
  checkStatusRollbackVersion, loadLogRollbackVersion,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { BACKEND_URL_V2, ROLLBACK_VERSION_STATUS } from '../../../configs';
import { dateTimeStringFormatter } from '../../../utils/formatters';
import { SYSTEM_MODULE } from '../../../configs/moduleNames';
import { CREATED } from '../../../configs/serverStatusCodes';

const getStop = state => {
  const {
    [SYSTEM_MODULE]: {
      stopProgressBar = false,
    },
  } = state;
  return stopProgressBar;
};

export default function* rollbackVersion(action) {
  try {
    const url = `${BACKEND_URL_V2}/audit/rollback-plans/${action.payload.id}/confirm`;
    const dataResponse = yield makeRequest(url, { data: action.payload.data }, action, 'POST', true, true);
    const data = yield dataResponse.json();

    if (data?.data?.status === ROLLBACK_VERSION_STATUS.CONFIRMING && dataResponse?.status === CREATED) {
      yield put(showProgressBar({
        title: 'Процесс восстановления версии',
        text: 'return.version',
      }));
      let stopImport = false;
      while (!stopImport) {
        stopImport = yield select(getStop);
        const registryLoadPromise = yield put(checkStatusRollbackVersion(action.payload.id));
        const {
          total_items, status, progress, processed_items, id,
        } = yield registryLoadPromise;

        const logLoadPromise = yield put(loadLogRollbackVersion(action.payload.id));
        const { data: logs } = yield logLoadPromise;

        yield put(setProgressList({
          progressCount: total_items,
          progressPercent: progress,
          progressCountSuccess: processed_items,
        }));
        yield put(setLogList({ log: renderLog(logs) }));
        if (status === ROLLBACK_VERSION_STATUS.SUCCESS) {
          yield put(stoppedProgressBar());
          break;
        }
        yield delay(2000);
      }
      yield put(addProgressLog({ log: 'Процесс восстановления версии завершен' }));
      yield put(rollbackVersionSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(rollbackVersionFailed());
      yield handleImportFailure(data?.message);
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(rollbackVersionFailed());
    yield handleImportFailure(e);
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}

const renderLog = items => {
  const errorMessages = items.map(e => {
    const message = e.message || 'Ошибка без сообщения';
    const timestamp = e.created_at ? `[${dateTimeStringFormatter(e.created_at)}]` : '';
    return `${timestamp} ${message}`;
  });
  return errorMessages.map(msg => `<span>${msg}</span><br/>`);
};

function* handleImportFailure(error) {
  const time = moment().format('HH:mm:ss');
  yield put(addProgressLog({ log: `<span style="color: red">${time} - Ошибка импорта: ${error || 'Ошибка без сообщения'}</span>`, withOutTime: true }));
  yield put(stoppedProgressBar());
  yield put(setProgressList({ progressPercent: 100 }));
}
